import React from "react";
import { Link } from "react-router-dom";
import RulesTable from "components/RulesTable";
import WithAuth from "../containers/WithAuth";
import { USER_PERMISSIONS } from "../utils/authConstants";
import { Fab } from "@material-ui/core";
import { Add } from "@material-ui/icons";

class Rules extends React.PureComponent {
  render() {
    return (
      <div>
        <RulesTable />
        <Fab
          color="secondary"
          aria-label="add"
          style={{ position: "absolute", right: "20px", bottom: "20px" }}
        >
          <Link
            to="/rules/new"
            style={{
              textDecoration: "none",
              color: "inherit",
              lineHeight: "normal"
            }}
          >
            <Add />
          </Link>
        </Fab>
      </div>
    );
  }
}

export default WithAuth(Rules, USER_PERMISSIONS.CAN_ACCESS_RULES);



// WEBPACK FOOTER //
// ./src/pages/Rules.js